import React, { useEffect, useState } from "react";
import "./LeadExecutiveDashboard.css";
import {
  Bar,
  HorizontalBar,
  BarChart,
  XAxis,
  YAxis,
  CartesianGrid,
} from "react-chartjs-2";
import axios from "axios";
import { environment } from "../../../environment";
import Select from "react-select";

const LeadExecutiveDashboard = () => {
  const [fname, setFname] = useState("");
  const [Date, setDate] = useState("this-week");
  const [LocationOption, setLocationOption] = useState([
    { label: "All Locations", value: "", deviceCount: 0 },
  ]);
  const [Location, setLocation] = useState("");
  const [Industry, setIndustry] = useState("");

  const [OverviewTotal, setOverviewTotal] = useState("");
  const [OverviewConverted, setOverviewConverted] = useState("");
  const [OverviewFollowUps, setOverviewFollowUps] = useState("");
  const [OverviewOnHold, setOverviewOnHold] = useState("");

  const [PlaceInfo, setPlaceInfo] = useState([]);
  const [LIVData, setLIVData] = useState([]);
  const [CustomerData, setCustomerData] = useState([]);

  useEffect(() => {
    let UserName = JSON.parse(localStorage.getItem("user"));
    setFname(UserName.userFirstName);

    LocationDropdown();
    GetLocation(LocationOption[0]);
    getOverviewData("this-week", "", "");
    getPlacesData("this-week", "", "");
    getIVData("this-week", "", "");
    GetCustomersData("this-week", "", "");
  }, []);
  const LIVdata = {
    labels: [
      "Healthcare",
      "Hospitality",
      "Educational",
      "Corporate",
      "Manufacturing Unit",
      "Others",
    ],
    datasets: [
      {
        label: "LEADS OF INDUSTRY VERTICALS",
        data: LIVData,
        backgroundColor: [
          "#00B8A9",
          "#FFBF00",
          "#FF7000",
          "#540375",
          "#CE7777",
          "#baba44",
        ],
      },
    ],
  };

  const GetDate = (event) => {
    console.log(event.target.value);
    setDate(event.target.value);
    getOverviewData(event.target.value, Location, Industry);
    getPlacesData(event.target.value, Location, Industry);
    getIVData(event.target.value, Location, Industry);
    GetCustomersData(event.target.value, Location, Industry);
  };

  const LocationDropdown = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let userId = userDetails.data.id.id;

    axios
      .get(environment.dap_url + "dashboardApi/getLeadsLocation/" + userId)
      .then((res) => {
        console.log(res.data);
        let LocationArr = [];
        // LocationArr.push({ _id: "", deviceCount: 0 });

        let locArr = [...LocationOption];
        for (let i = 0; i < res.data.length; i++) {
          // LocationArr.push(res.data[i]._id);
          locArr.push({
            label: res.data[i]._id,
            value: res.data[i]._id,
            deviceCount: res.data[i].deviceCount,
          });
        }
        // setLocationDropDown()
        console.log(LocationArr);
        setLocationOption(locArr);
      });
  };

  const GetLocation = (event) => {
    if (event) {
      console.log(event.value);
      setLocation(event.value);
      getOverviewData(Date, event.value, Industry);
      getPlacesData(Date, event.value, Industry);
      getIVData(Date, event.value, Industry);
      GetCustomersData(Date, event.value, Industry);
    }
  };

  const GetIndustryData = (event) => {
    console.log(event.target.value);
    setIndustry(event.target.value);
    getOverviewData(Date, Location, event.target.value);
    getPlacesData(Date, Location, event.target.value);
    getIVData(Date, Location, event.target.value);
    GetCustomersData(Date, Location, event.target.value);
  };

  const getOverviewData = (d, loc, ind) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let userId = userDetails.data.id.id;
    console.log(userId);
    axios
      .get(
        environment.dap_url +
          "dashboardApi/lead_overview/" +
          userId +
          "?date=" +
          d +
          "&location=" +
          loc +
          "&industry=" +
          ind
      )
      .then((res) => {
        console.log("OverViewData", res.data);
        setOverviewTotal(res.data.total);
        setOverviewConverted(res.data.converted);
        setOverviewFollowUps(res.data.followUp);
        setOverviewOnHold(res.data.onhold);
      });
  };

  const getPlacesData = (d, loc, ind) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let userId = userDetails.data.id.id;
    console.log(userId);
    axios
      .get(
        environment.dap_url +
          "dashboardApi/city_overview/" +
          userId +
          "?date=" +
          d +
          "&location=" +
          loc +
          "&industry=" +
          ind
      )
      .then((res) => {
        console.log("getPlacesInfo", res.data);
        setPlaceInfo(res.data);
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  const getIVData = (d, loc, ind) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let userId = userDetails.data.id.id;
    axios
      .get(
        environment.dap_url +
          "dashboardApi/lead_industry_Overview/" +
          userId +
          "?date=" +
          d +
          "&location=" +
          loc +
          "&industry=" +
          ind
      )
      .then((res) => {
        console.log("getIVData", res.data);
        let LIVArr = [];
        LIVArr.push(res.data.healthcare);
        LIVArr.push(res.data.hospitality);
        LIVArr.push(res.data.educational);
        LIVArr.push(res.data.corporate);
        LIVArr.push(res.data.manufacturing);
        LIVArr.push(res.data.others);

        setLIVData(LIVArr);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const GetCustomersData = (d, loc, ind) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let userId = userDetails.data.id.id;
    console.log(userId);
    axios
      .get(
        environment.dap_url +
          "dashboardApi/customer_Overview/" +
          userId +
          "?date=" +
          d +
          "&location=" +
          loc +
          "&industry=" +
          ind
      )
      .then((res) => {
        console.log("GetCustomerData", res.data);
        setCustomerData(res.data);
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  return (
    <>
      <div className="Main_Dashboard">
        <div class="app-main__inner">
          <div class="row welcome-drop">
            <div class="col-lg-4 col-12">
              <h2 class="wlcm-head">
                Welcome <span>{fname}!</span>
              </h2>
            </div>
            <div class="col-lg-8 col-12">
              <div class="row top-sele-box">
                <div class="col-lg-4-col-12">
                  <div class="dt-sl">
                    <select name="date" id="date" onChange={GetDate}>
                      <option value="this-week">This Week</option>
                      <option value="last-week">Last Week</option>
                      <option value="this-month">This Month</option>
                      <option value="last-month">Last Month</option>
                      <option value="this-year">This Year</option>
                      <option value="last-year">Last Year</option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-4-col-12">
                  <div class="stc-sl">
                    <Select
                      id="LocationDropdown"
                      options={LocationOption.map((data) => ({
                        label: data.label,
                        value: data.value,
                      }))}
                      onChange={GetLocation}
                      value={{
                        label: Location == "" ? "All location" : Location,
                        value: Location == "" ? "All location" : Location,
                      }}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          border: "none",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          color: "black",
                          fontSize: "18px",
                        }),
                      }}
                    />
                  </div>
                </div>

                <div class="col-lg-4-col-12">
                  <div class="stc-sl">
                    <select name="civ" id="civ" onChange={GetIndustryData}>
                      <option value="">All Industries</option>
                      <option value="Healthcare">Healthcare</option>
                      <option value="Hospitality">Hospitality</option>
                      <option value="Education">Educational</option>
                      <option value="Corporate">Corporate</option>
                      <option value="Manufacturing">Manufacturing Unit</option>
                      <option value="Others">Others</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" id="widget_Cards_header">
            <span style={{ marginLeft: "-10px" }}>Lead Status</span>
          </div>
          <div className="Location_per">
            <div style={{ paddingLeft: "15px" }}>
              <span id="widget_Cards_top">Overview</span>
            </div>

            <div
              class="row"
              id="widget_Cards"
              style={{ paddingLeft: "15px", paddingRight: "15px" }}
            >
              <div class="col">
                <div class="card mb-3 widget-content bg-Total-Leads">
                  <div class="widget-content-wrapper text-white">
                    <div class="widget-content-left">
                      <div class="widget-heading" style={{ fontSize: "20px" }}>
                        <img
                          src={require("../../Components/assets/images/icons/In_Stock.svg")}
                          alt=""
                        />
                        Total Leads
                      </div>
                    </div>
                    <div class="widget-content-right">
                      <div class="widget-numbers text-white">
                        <span>{OverviewTotal}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="card mb-3 widget-content bg-Converted">
                  <div className="widget-content-wrapper text-white">
                    <div className="widget-content-left">
                      <div
                        className="widget-heading"
                        style={{ fontSize: "20px", color: "#FFFFFF" }}
                      >
                        <img
                          src={require("../../Components/assets/images/icons/Active.svg")}
                          alt=""
                        />
                        Converted
                      </div>
                    </div>
                    <div className="widget-content-right">
                      <div className="widget-numbers text-white">
                        <span>{OverviewConverted}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="card mb-6 widget-content bg-Follow-ups">
                  <div class="widget-content-wrapper text-white">
                    <div class="widget-content-left">
                      <div
                        class="widget-heading"
                        style={{ fontSize: "20px", color: "#FFFFFF" }}
                      >
                        <img
                          src={require("../../Components/assets/images/icons/FollowUp.svg")}
                          alt=""
                        />{" "}
                        Follow ups
                      </div>
                    </div>
                    <div class="widget-content-right">
                      <div class="widget-numbers text-white">
                        <span>{OverviewFollowUps}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="card mb-3 widget-content bg-On-hold">
                  <div class="widget-content-wrapper text-white">
                    <div class="widget-content-left">
                      <div
                        class="widget-heading"
                        style={{ fontSize: "20px", color: "#FFFFFF" }}
                      >
                        <img
                          src={require("../../Components/assets/images/icons/Damaged.svg")}
                          alt=""
                        />
                        On hold
                      </div>
                    </div>
                    <div class="widget-content-right">
                      <div class="widget-numbers text-white">
                        <span>{OverviewOnHold}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="row"
            style={{ paddingLeft: "15px", paddingRight: "15px" }}
          >
            <div class="col-md-3 col-12" style={{ paddingRight: -"10px" }}>
              <div class="mb-3 card">
                <div class="card-header-tab card-header-tab-animation card-header">
                  <div class="card-header-title" style={{ color: "#8A93A3" }}>
                    TOP CITY LEADS
                  </div>
                </div>
                <div class="card-body" style={{ height: "380px" }}>
                  <div class="location" style={{ overflowy: "scroll" }}>
                    {PlaceInfo.map((item) => (
                      <div
                        class="Location_per"
                        style={{ paddingBottom: "20px" }}
                      >
                        <div
                          class="row"
                          style={{ justifyContent: "space-between" }}
                        >
                          <p style={{ fontWeight: "500" }}>{item._id}</p>
                          <p style={{ fontWeight: "500" }}>{item.count}</p>
                        </div>
                        <div
                          class="row"
                          style={{ justifyContent: "space-between" }}
                        >
                          <progress
                            value={item.percentage}
                            max="100"
                            style={{ width: "80%", height: "10px" }}
                          ></progress>
                          <span style={{ marginTop: "-8px" }}>
                            {item.percentage}%
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="mb-3 card">
                <div class="card-header-tab card-header-tab-animation card-header">
                  <div class="card-header-title" style={{ color: "#8A93A3" }}>
                    LEADS OF INDUSTRY VERTICALS
                  </div>
                </div>
                <div
                  className="card-body"
                  style={{
                    height: "380px",
                    paddingtop: 0,
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      width: "90%",
                      height: "100%",
                      marginTop: "5%",
                    }}
                  >
                    <HorizontalBar
                      id="horizontalBarChartCanvasIndustry"
                      className="horizontal-bar-styling"
                      width={800}
                      height={380}
                      options={{
                        scales: {
                          xAxes: [
                            {
                              ticks: { stepSize: 1, beginAtZero: true },
                              gridLines: {
                                display: false,
                              },
                              gridLines: {
                                zeroLineWidth: 1,
                              },
                            },
                          ],
                          yAxes: [
                            {
                              gridLines: {
                                display: false,
                              },
                            },
                          ],
                        },
                        legend: {
                          display: false,
                        },
                      }}
                      data={LIVdata}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-12">
              <div class="mb-3 card">
                <div class="card-header-tab card-header-tab-animation card-header">
                  <div class="card-header-title" style={{ color: "#8A93A3" }}>
                    CUSTOMERS
                  </div>
                </div>
                <div class="card-body" style={{ height: "380px" }}>
                  <div class="scroll-area-sm" style={{ height: "100%" }}>
                    <ul class="rm-list-borders list-group list-group-flush">
                      {CustomerData.map((item) => (
                        <li class="list-group-item">
                          <div class="widget-content p-0">
                            <div
                              class="widget-content-wrapper"
                              style={{ justifyContent: "space-between" }}
                            >
                              <div class="widget-content-left mr-3">
                                <img
                                  width="42"
                                  class="rounded-circle"
                                  src="https://picsum.photos/300/300"
                                  alt=""
                                />
                              </div>
                              <div class="widget-content-left">
                                <h6>{item.userFirstName}</h6>
                                <div class="widget-subheading">
                                  {item.organization}
                                </div>
                              </div>
                              <div class="widget-content-right ml-auto">
                                <div class="font-size-xlg text-muted">
                                  <span class="p-green">Paid</span>
                                  <small>{item.user.userFirstName}</small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                    <div
                      className="v-all-btn"
                      style={{
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                        paddingBottom: "10px",
                        paddingRight: "15px",
                      }}
                    >
                      <a href="/customer">
                        <u>View All</u>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadExecutiveDashboard;
